<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <VSelect
      label="Стройка"
      name="building"
      ref="selectBuilding"
      :items="buildingList"
      :handler-search="GETBuildingList"
      :disabled="isParentEntityPage"
      :search="!isParentEntityPage"
      @change="changeBuilding"
    />

    <VSelect
      label="Объект"
      name="object"
      ref="selectObject"
      :items="objectList"
      :handler-search="GETObjectListByBuildId"
      :disabled="isParentEntityPage"
      :search="!isParentEntityPage"
      @change="changeObject"
    />

    <VInput
      v-if="!isEdit"
      label="Шифр бух."
      name="accounting_cipher"
      disabled
    />

    <VSelect
      v-if="!isEdit"
      label="Ответственный сметный"
      name="estimate_responsible"
      :items="userList"
      :handler-search="GETUserList"
      disabled
      search
    />

    <VInput
      label="Наименование проекта"
      name="name"
      required
      min-length="3"
    >
      <Validation for="required">Поле обязательно</Validation>
      <Validation for="minLength">Минимальная длина названия 3 символа</Validation>
    </VInput>

    <VInput
      label="Шифр проекта"
      name="project_cipher"
    />

    <AppInputDate
      title="Дата начала"
      name="start_date"
      type="single"
    />

    <AppInputDate
      title="Дата окончания"
      name="stop_date"
      type="single"
    />

    <div v-if="isEdit" class="line form__line" />

    <AppInputDate
      title="Дата получения"
      name="receive_date"
      type="single"
      :value="!isEdit ? currentDate : modelFormData.receive_date"
    />

    <VSelect
      label="Статус"
      name="status"
      :items="statusProjectList"
      :handler-search="GETStatusProjectList"
      search
    />

    <VSelect
      label="ИД"
      name="i_d"
      :items="handbookIDList"
      :handler-search="GETHandbookIDList"
      search
    />

    <VSelect
      label="Ответственный ПТО"
      name="pto_responsible"
      :items="userList"
      :handler-search="GETUserList"
      search
      userSelect
    />

    <VSelect
      label="Назначить соисполнителей ПТО"
      name="co_executors"
      :items="userList"
      :handler-search="GETUserList"
      withCheckbox
      multiple
      search
      userSelect
    />

    <VCheckbox
      title="Отсутствует смета"
      name="is_no_estimate"
      :value="noEstimate"
      :disabled="!isEdit"
      class="form__checkbox-wrap"
      @valueChange="changeIsNoEstimate"
    />

    <VInput
      v-if="isEdit ? noEstimate : true"
      label="Стоимость проекта"
      name="price_no_estimate"
      :required="isEdit ? noEstimate : true"
      pattern="^\d*(?:[.]\d{0,3})?$"
    >
      <Validation for="required">Поле обязательно</Validation>
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>

    <VCheckbox
      v-if="isEdit"
      title="Без материалов"
      name="is_no_materials"
      class="form__checkbox-wrap"
    />

    <div v-if="isEdit" class="line form__line" />

    <VCheckbox
      v-if="isEdit"
      title="Отдать в субподряд"
      ref="checkboxIsSubContract"
      name="is_sub_contract"
      class="form__input--col-2 form__checkbox-wrap"
      @valueChange="changeIsSubContract"
    />

    <transition name="fade">
      <VSelect
        v-if="visibleSubContractBlock"
        label="Договор с субподрядчиком"
        name="treaty"
        item-text="treaty_number"
        :items="contractsList"
        :handler-search="GETContractsList"
        search
        @change="changeTreaty"
      />
    </transition>

    <transition name="fade">
      <VInput
        v-if="visibleSubContractBlock"
        label="Г/П к получению %"
        name="receive_percent"
        pattern="^\d*(?:[.]\d{0,3})?$"
    >
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>
    </transition>

    <transition name="fade">
      <router-link
        v-if="visibleTreatyLink"
        class="form__link form__input--col-2"
        target="_blank"
        :to="{ name: 'ContractUpdate', params: { id: treatyId } }"
      >
        Смотреть договор
      </router-link>
    </transition>

    <transition name="fade">
      <VSelect
        v-if="visibleSubContractBlock"
        label="Субподрядчик"
        name="sub_contractor"
        item-text="long_name"
        :items="partnerList"
        :handlerSearch="GETPartnerList"
        search
      />
    </transition>

    <div v-if="isEdit" class="line form__line" />
  </FormPto>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import FormPto from '@/components/pto/form/FormPto'
import Validation from '@/components/page/Form/Validation.vue'
import VCheckbox from '@/components/page/Form/VCheckbox/VCheckbox'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect.vue'

import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'
import { mixinPtoProjectSelect } from '@/mixins/module/pto/mixinPtoProjectSelect'

import Vue from 'vue'
import { mapMutations, mapState, mapActions } from 'vuex'
import { currentDate, formatDateForServer } from '@/utils/utils'
import { prepareProjectFormData } from '@/utils/page/pto/project'

export default {
  name: 'FormPtoProject',
  components: {
    AppInputDate,
    FormPto,
    Validation,
    VCheckbox,
    VInput,
    VSelect
  },

  mixins: [MIXIN_FORM_PTO, MIXIN_USER_LIST, mixinPtoProjectSelect],

  data: () => ({
    buildingId: null,
    isSubContract: false,
    isNoEstimate: true,
    treatyId: null
  }),

  computed: {
    ...mapState('handbook/partner', {
      partnerList: 'partnerList'
    }),

    visibleSubContractBlock () {
      return this.isEdit && this.isSubContract
    },

    visibleTreatyLink () {
      return this.visibleSubContractBlock && this.treatyId
    },

    currentDate () {
      let date = new Date(currentDate())
      date = formatDateForServer(date)
      return date
    },

    noEstimate () {
      return this.isNoEstimate
    }
  },

  mounted () {
    if (this.isEdit) {
      this.loadOneItem(this.$route.params.projectId)
      this.isNoEstimate = this.modelFormData?.is_no_estimate
      this.isSubContract = this.modelFormData?.is_sub_contract
      this.treatyId = this.modelFormData?.treaty?.id
    }
  },

  methods: {
    ...mapMutations('pto/project', {
      ADD_FILE_TO_DELETE: 'ADD_FILE_TO_DELETE'
    }),
    ...mapActions('handbook/partner', {
      GETPartnerList: 'GETPartnerList'
    }),
    ...mapActions('pto/project', {
      loadOneItem: 'loadOneItem'
    }),

    onSubmit (data) {
      this.$emit('request', prepareProjectFormData(data))
    },

    async changeBuilding (value) {
      Vue.set(this.modelFormData, 'accounting_cipher', value?.accounting_cipher)
      this.buildingId = value?.id

      // Обнуление выбора объекта, если он не относится к выбранной стройке
      if (this.$refs.selectObject.inputValue) {
        if (this.buildingId !== this.$refs.selectObject.inputValue?.building_id) {
          this.$refs.selectObject.inputValue = null
          Vue.set(this.modelFormData, 'estimate_responsible', null)
        }
      }

      await this.GETObjectListByBuildId()
    },

    changeObject (data) {
      const responsible = {
        id: data?.estimate_responsible?.id,
        name: data?.estimate_responsible?.profile?.full_name
      }

      Vue.set(this.modelFormData, 'estimate_responsible', responsible)
    },

    changeIsSubContract (value) {
      this.isSubContract = value
    },

    changeIsNoEstimate (value) {
      this.isNoEstimate = value
    },

    changeTreaty (value) {
      this.treatyId = value?.id
    },

    GETObjectListByBuildId ({ search = null } = {}) {
      return this.GETObjectList({
        buildingId: this.buildingId,
        search
      })
    }
  }
}
</script>
